/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserProcessingStateFromJSON, UserProcessingStateToJSON, } from './UserProcessingState';
/**
 * Check if a given object implements the CreatorFileProcessingResponse interface.
 */
export function instanceOfCreatorFileProcessingResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function CreatorFileProcessingResponseFromJSON(json) {
    return CreatorFileProcessingResponseFromJSONTyped(json, false);
}
export function CreatorFileProcessingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reportId': !exists(json, 'reportId') ? undefined : json['reportId'],
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'state': !exists(json, 'state') ? undefined : UserProcessingStateFromJSON(json['state']),
        'percent': !exists(json, 'percent') ? undefined : json['percent'],
        'earlierReportId': !exists(json, 'earlierReportId') ? undefined : json['earlierReportId'],
    };
}
export function CreatorFileProcessingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reportId': value.reportId,
        'fileId': value.fileId,
        'fileName': value.fileName,
        'state': UserProcessingStateToJSON(value.state),
        'percent': value.percent,
        'earlierReportId': value.earlierReportId,
    };
}
